import React from 'react';
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import PeiChart from "@containers/facility/Overview/PieChart";
import { useAuth } from '@/hooks/use-auth';
import { Nopermission } from '@/components/Nopermission';
import { useNavigate } from 'react-router-dom';
import { emitEvent } from '@/hooks/useEventBus';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@redux/app/actions';

const EquipmentByConditionChart = () => {
    const equipmentPermission = useAuth('equipment');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);

    const { data: equipmentData } = useRequest(
        () => api.allequipmentview(),
        {
            ready: equipmentPermission,
            cacheKey: `equipment-condition-chart-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    if (!equipmentPermission) {
        return <Nopermission />;
    }

    const equipmentConditionData = equipmentData?.data?.grouped_status_data;

    if (!equipmentConditionData) {
        return null
    }

    const handleEquipmentConditionClick = (e) => {
        emitEvent('CLOSE_EQUIPMENT');
        const url = '/facility/equipment?condition=' + e.data.name;
        navigate(url);
        dispatch(appActions.changeCurrent(['equipment']));
    };

    return (
        <PeiChart
            data={equipmentConditionData}
            height={200}
            title={'Equipment by Condition'}
            handleChartClick={handleEquipmentConditionClick}
        />
    );
};

export default EquipmentByConditionChart; 